export const createAction = (type: string, payload: any) => ({ type, payload });